module.exports = __webpack_public_path__ + "img/dataflow-04.40059229.svg";